import { styled } from '@mui/material'
import { NavLink } from 'react-router-dom'

import { Button } from '../Button'

export const Link = styled(NavLink)(({ theme }) => ({
  display: 'flex',
  width: '100%',
  textDecoration: 'none',
  '&.active .MuiButton-root': {
    backgroundColor: theme.palette.secondary.main,
    color: theme.palette.text.inverse,
    '.MuiButton-icon': {
      color: theme.palette.text.inverse,
    },
    '.MuiTypography-root': {
      fontWeight: theme.typography['body-bold'].fontWeight,
    },
  },
})) as typeof NavLink

export const TabButton = styled(Button)(({ theme, ...props }) => ({
  backgroundColor: 'transparent',
  height: '50px',
  width: '100%',
  borderRadius: theme.spacing.S,
  color: theme.palette.text.inverse,
  '&.MuiButton-root': {
    justifyContent: props.open ? 'flex-start' : 'center',
    gap: theme.spacing.SM,
  },
  '& .MuiButton-icon': {
    padding: 0,
    margin: 0,
    color: theme.palette.text.inverse,
  },
  '&:hover': {
    backgroundColor: theme.palette.background['a-hover-inverse'],
    color: theme.palette.text.inverse,
    '& .MuiButton-icon': { color: theme.palette.text.inverse },
  },
  '&:focus': {
    border: 0,
  },
})) as typeof Button
